import Hero from "../components/Hero";
import Services from "../components/Services";
import Featured from "../components/Featured";
import Footer from "../components/Footer";

function Home() {
  return (
    <section>
      <Hero />
      <Services />
      <Featured />
      <Footer />
    </section>
  );
}

export default Home;
